import { forwardRef, useId, type TextareaHTMLAttributes } from 'react';
import clsx from 'clsx';
import styles from './TextArea.module.scss';

export interface NebiTextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
  fullWidth?: boolean;
}

/** Espelho de `nebi/Input` para texto longo: mesmo contrato de rótulo e mensagem. */
export const TextArea = forwardRef<HTMLTextAreaElement, NebiTextAreaProps>(function TextArea(
  { label, error, helperText, fullWidth = true, className, id, rows = 4, ...rest },
  ref,
) {
  const autoId = useId();
  const textAreaId = id ?? `nebi-textarea-${autoId}`;
  const msgId = `${textAreaId}-msg`;
  const message = error ?? helperText;

  return (
    <div className={clsx(styles.wrapper, fullWidth && styles.fullWidth, className)}>
      {label && (
        <label className={styles.label} htmlFor={textAreaId}>
          {label}
        </label>
      )}
      <textarea
        ref={ref}
        id={textAreaId}
        rows={rows}
        className={clsx(styles.textarea, error && styles.invalid)}
        aria-invalid={error ? true : undefined}
        aria-describedby={message ? msgId : undefined}
        {...rest}
      />
      {message && (
        <span id={msgId} className={clsx(styles.message, error && styles.errorText)}>
          {message}
        </span>
      )}
    </div>
  );
});

export default TextArea;
